import React from 'react';
import { Link } from 'react-router-dom'


export default class Not_Found extends React.Component{

    render() {
        return(<div className="not-Found">
                   <div className="not-found-content">
                        <figure>
                            <img src="/images/dokkit-logo.png" alt="dokkit-logo" />
                        </figure>
                        <h1>404 !</h1>
                        <h2>Oops..!! It seems you entered a wrong url. Please click below to go back to homepage. !</h2>
                        <Link to="/" className="btn btn-primary">Back to home</Link>
                   </div> 
               </div>
            )
    }
} 


// WEBPACK FOOTER //
// ./src/Components/Pages/404.js